/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const TopPage: React.FC<Props> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.47505 2.35C3.10226 2.35 2.80005 2.04779 2.80005 1.675C2.80005 1.30221 3.10226 1 3.47505 1H16.525C16.8978 1 17.2 1.30221 17.2 1.675C17.2 2.04779 16.8978 2.35 16.525 2.35H3.47505Z"
      fill={color ?? props?.style?.color}
    />
    <path
      d="M3.89775 10.8727C3.63415 11.1363 3.63415 11.5637 3.89775 11.8273C4.16136 12.0909 4.58874 12.0909 4.85235 11.8273L9.32505 7.35459V18.325C9.32505 18.6978 9.62726 19 10 19C10.3728 19 10.675 18.6978 10.675 18.325V7.35459L15.1478 11.8273C15.4114 12.0909 15.8387 12.0909 16.1023 11.8273C16.366 11.5637 16.366 11.1363 16.1023 10.8727L10.4773 5.2477C10.2137 4.9841 9.78636 4.9841 9.52275 5.2477L3.89775 10.8727Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default TopPage;
